"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var actions_1 = require("../../../redux/reducers/app/actions");
var MessageBar = function () {
    var theme = (0, core_1.useTheme)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, react_redux_1.useSelector)(function (state) { return state.app; }), showMessage = _a.showMessage, message = _a.message, type = _a.type, messageTimeout = _a.messageTimeout, messageParams = _a.messageParams;
    var onClose = function () {
        dispatch((0, actions_1.clearMessages)());
    };
    return showMessage && message ? (react_1.default.createElement(package_1.MessageBar, { type: type, message: message, showMessage: showMessage, successColor: theme.palette.success.main, warningColor: theme.palette.error.main, clearMessages: onClose, messageParams: messageParams, messageTimeout: messageTimeout })) : null;
};
exports.default = MessageBar;
//# sourceMappingURL=MessageBar.js.map